// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusUpleftOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusUpleftOutlined";
import AntdIcon from '../components/AntdIcon';

var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlinedSvg
  }));
};

RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
export default React.forwardRef(RadiusUpleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RadiusUpleftOutlined.js
// module id = 1669
// module chunks = 0